import * as React from "react";
import { Box, IconButton, makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import { TransitionProps } from "@material-ui/core/transitions";
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "../model/state-models";
import { Item } from "../model/search-base-model";
import { setShowDetail } from "../slice/search-slice";
import { imgRoot } from "../constant/app-paths";

const useStyles = makeStyles((theme) => ({
  img: {
    width:540,
    height: 'auto',
  },
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function ItemDetail() {
  const detail = useSelector<AppState<any>, Item>(
    (state) => state?.searchState?.selectedItem
  );

  const open = useSelector<AppState<any>, boolean>(
    (state) => state?.searchState?.showDetail
  );
  const classes = useStyles();
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setShowDetail(false));
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <IconButton
        edge="start"
        color="inherit"
        onClick={handleClose}
        aria-label="close"
      >
        <Typography variant="h4">Back</Typography>
      </IconButton>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        {detail?.imageUrl && (
          <Typography variant="body1">
            <img className={classes.img} src={`${imgRoot}${detail?.imageUrl}`} />
          </Typography>
        )}
      </Box>
    </Dialog>
  );
}
